<h1 mat-dialog-title> Valida Postulación Matrimonio </h1> <br/>

<mat-dialog-content>
  
    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <p> Beneficiario </p>

            <mat-select *ngIf="data.carga" [(ngModel)]="data.beneficiario" [disabled]="data.deshabilitado" required>

                <mat-option *ngFor="let postulante of data.postulantes" value="{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.beneficiario" />

        </mat-form-field>
    </p>
    <form #matrimonioForm=ngForm>
     <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Tipo Matrimonio</p>           
        </div>
        <div class="col-lg-5">
           
            <mat-select class="form-control" [(value)]="data.tipoUnion" name="tipoUnion" #tipoUnion="ngModel"
                [(ngModel)]="data.tipoUnion"  [disabled]="data.deshabilitado" required>
                 
                <mat-option value="0">
                    SELECCIONE....
                </mat-option>
                <mat-option *ngFor="let tipo of data.tipoMatrimonios"  [value]="tipo.id">
                    {{tipo.descripcion}}
                </mat-option>
            </mat-select>

        </div>

        <div class="col-lg-3"> </div>

    </div>
    <br />

    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Rut Cónyuge </label> </div>

        <div class="col-lg-5">

            <input id="rutConyuge" name="rutConyuge" #rutConyuge="ngModel" [(ngModel)]="data.rutConyuge"
                class="form-control"  required type="text"  [disabled]="data.deshabilitado" />

        </div>
        <div class="col-lg-3">   <div class="col-lg-3">
            <button class="btn btn-info" [disabled]="data.deshabilitado" (click)="buscarHijo(data.rutConyuge)">
                Consultar
            </button>
        </div></div>
    </div>
    <br />
    
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> nombre Completo Cónyuge </label> </div>

        <div class="col-lg-5">

            <input id="nombreCompletoConyuge" name="nombreCompletoConyuge" #nombreCompletoConyuge="ngModel" [(ngModel)]="data.nombreCompletoConyuge"
            class="form-control"  [disabled]="data.deshabilitado" required type="text" />


        </div>
        <div class="col-lg-3"> </div>
    </div>
    <br />
 
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Fecha Matrimonio </label> </div>

        <div class="col-lg-5">

            <input id="fechaUnion" name="fechaUnion" #nombres="ngModel" placeholder="Fecha Unión" 
            class="form-control" type="date"  required [(ngModel)]="data.fechaUnion" [disabled]="data.deshabilitado" required />


        </div>
        <div class="col-lg-3"> </div>
    </div>
    <br />

  
    <p>
        <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
    </p>
</form>
</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-warning" (click)="onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-success" (click)="onAprobarClick()">
            <i class = "fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(matrimonioForm)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>

    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>